class NewsCenterController {
    constructor($state,$filter, AnnouncementAPI, AnnouncementTagAPI) {
        "ngInject";
        this.tranlsteFilter=$filter('translate');
        this.AnnouncementTagAPI = AnnouncementTagAPI;
        this.AnnouncementAPI = AnnouncementAPI;
        this.$state = $state
        this.articles = [];
        this.page = 1;
        this.minimum = 1
        this.canSeeNumber = 3
        this.page_size = 20;
        this.total_page = 0;
        this.tags = [];
        this.currentTag = -1;
        this.articles.fill(
          {
              thumb: 'http://www.aliued.com/wp-content/uploads/2017/02/C7C970CB-18A4-4261-B2F9-665962E8EEAC.jpg',
              title: '【原本资讯】「原本链」网站开放展示接口文档页面',
              time: '2018.05.18',
              desc: '「原本链」近期在官网上开放了接口的文档。其中展示了：原本链部署文档、API描述文档、sdk接口使用文档、license介绍文档、区块数据介绍、metadata介绍。并且还支持原本链项目PPT的下载。文档的开放展示，使以前对原本链不熟悉的「原本链」近期在官网上开放了接口的文档。其中展示了：原本链部署文档、API描述文档、sdk接口使用文档、license介绍文档、区块数据介绍、metadata介绍。并且还支持原本链项目PPT的下载。文档的开放展示，使以前对原本链不熟悉的「原本链」近期在官网上开放了接口的文档。其中展示了：原本链部署文档、API描述文档、sdk接口使用文档、license介绍文档、区块数据介绍、metadata介绍。并且还支持原本链项目PPT的下载。文档的开放展示，使以前对原本链不熟悉的',
          },
          0,
          6
        )
        this.loadArticles(() => this.caculateRange())
    }

    caculateRange () {
        this.maxmum = this.canSeeNumber < this.total_page ?  this.minimum + this.canSeeNumber - 1 : this.total_page;
        const arr = []
        for (var i = this.minimum; i <= this.maxmum; i ++) {
            arr.push(i)
        }
        console.log(arr)
        this.pageArr = arr
    }

    loadTag () {
        this.AnnouncementTagAPI.one().get()
          .then(res => {
              this.tags = res
              this.currentTag = res[0]['id']
              this.loadArticles(() => {
                  if (this.total_page < this.canSeeNumber) this.canSeeNumber = this.total_page
                  this.caculateRange()
              })
          })
    }

    loadArticles (cb) {
        this.AnnouncementTagAPI.one().get({
            page: this.page,
            page_size: this.page_size,
            tag_id: this.currentTag
        }).then(res => {
            this.articles = res.data
            this.total_page = Math.ceil(res.total / 20)
            cb && cb()
        })
    }

    onChangeTag(tagId) {
        if (tagId === this.currentTag) return
        this.currentTag = tagId
        this.loadArticles()
    }

    goPage(page) {
        const intVal = parseInt(page)
        if (intVal !== 0 && !intVal) {
            if (page === 'prev') {
                this.page --
            } else if (page === 'next') {
                this.page ++
            } else {
                return
            }
            this.loadArticles(() => {
                if (this.page > this.maxmum) {
                    this.minimum ++
                } else if (this.page < this.minimum) {
                    this.minimum --
                }
                this.caculateRange()
            })
        } else {
            page = intVal
            if (page === this.page || page < 1 || page > this.total_page) return
            this.page = page
            this.loadArticles(() => {
                if (this.page > this.maxmum) {
                    this.minimum = this.page - this.canSeeNumber + 1
                } else if (this.page < this.minimum) {
                    this.minimum = this.page
                }
                this.caculateRange()
            })
        }
        scrollTo(0,0)
    }

    navigateTo(article) {
        if (article.link) {
            window.open(article.link, '_blank')
        } else {
            this.$state.go('app.page.news', {'id':article.id})
        }
    }
}

export default NewsCenterController;



// WEBPACK FOOTER //
// ./src/app/components/face/news-center/news-center.controller.js